import "./Footer.css"
import { FaYoutube ,FaTwitter, FaInstagram, FaTelegram } from "react-icons/fa";
import { trackSocialClick } from "../../utils/analytics";

function Footer() {
  return (
    <footer>
      <div className="socials-footer">
        <a
          href="https://www.youtube.com/@poceansblue"
          target="_blank"
          rel="noreferrer"
          onClick={() => trackSocialClick("youtube-footer")}
        >
          <FaYoutube className="social-icon youtube-icon" />
        </a>
        <a
          href="https://www.instagram.com/poceansblue/"
          target="_blank"
          rel="noreferrer"
          onClick={() => trackSocialClick("Instagram-footer")}
        >
          <FaInstagram className="social-icon instagram-icon" />
        </a>
        <a
          href="https://twitter.com/poceansblue"
          target="_blank"
          rel="noreferrer"
          onClick={() => trackSocialClick("twitter-footer")}
        >
          <FaTwitter className="social-icon twitter-icon" />
        </a>
        <a
          href="https://t.me/blueclub18"
          target="_blank"
          rel="noreferrer"
          onClick={() => trackSocialClick("telegram-footer")}
        >
          <FaTelegram className="social-icon telegram-icon" />
        </a>
      </div>

      <h4 className="copy-footer">
        تمام حقوق مادی و معنوی این سایت متعلق به بلوکلاب می‌باشد.{" "}
      </h4>
    </footer>
  );
}

export default Footer